import { useEffect, useState } from "react"

const DEFAULT_QUERIES = {
  sm: "(min-width: 640px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 1024px)",
}

export function useMediaQuery(query: string | keyof typeof DEFAULT_QUERIES) {
  const resolvedQuery = DEFAULT_QUERIES[query as keyof typeof DEFAULT_QUERIES] ?? query

  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined" || !("matchMedia" in window)) {
      return false
    }
    return window.matchMedia(resolvedQuery).matches
  })

  useEffect(() => {
    if (typeof window === "undefined" || !("matchMedia" in window)) {
      return
    }
    const mediaQuery = window.matchMedia(resolvedQuery)

    const handleChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    setMatches(mediaQuery.matches)
    mediaQuery.addEventListener("change", handleChange)
    return () => mediaQuery.removeEventListener("change", handleChange)
  }, [resolvedQuery])

  return matches
}

export function useBreakpoint(breakpoint: keyof typeof DEFAULT_QUERIES) {
  return useMediaQuery(DEFAULT_QUERIES[breakpoint])
}
